module.exports = __webpack_public_path__ + "img/new_travel.1e7700c6.svg";